import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminMediaEventsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('media-event');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
